import datapoints from './datapoints';
import moveMailListRows from './move/moveMailListRows';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Archive mail list rows from table
 * @param rowKeys the instance keys of the rows to archive
 * @param tableView the table view that contains the rows to archive
 * @param actionSource the action source that triggers the archive action
 */
export default select({
    archiveFolderId: function () { return getUserConfiguration().UserOptions.ArchiveFolderId; },
})(action('archiveMailListRowsFromTable', datapoints.archiveMailListRowsDatapoint)(function archiveMailListRowsFromTable(rowKeys, tableView, actionSource, state) {
    if (state.archiveFolderId) {
        moveMailListRows(rowKeys, state.archiveFolderId, tableView.id, 'NonUserAction');
    }
    else {
        // For new accounts and the existing accounts which have not setup the archive folder
        // the archive folder should get created as a default folder.
        throw new Error('Archive folder id should always be set');
    }
}));
//# sourceMappingURL=archiveMailListRows.js.map